// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1BJ_X","range":"MonthRangeSwitch_range__3WQaq","disabled":"MonthRangeSwitch_disabled__2wuNt"};